import { Component, OnInit } from '@angular/core';
import { PostDO } from '../common/data-objects/PostDO';
import { PostsService } from '../common/services/posts.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { SeoService } from '../common/services/seo.service';

@Component({
  selector: 'app-privacy-policy-page',
  templateUrl: './privacy-policy-page.component.html',
  styleUrls: ['./privacy-policy-page.component.scss']
})
export class PrivacyPolicyPageComponent implements OnInit {
  post: PostDO;
  isLoading: boolean;
  id: number;

  constructor(
    private postsService: PostsService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private meta: Meta,
    private seoService: SeoService
  ) {
  }

  ngOnInit() {
    this.getData();
  }

  private getData() {
    this.isLoading = true;
    this.postsService.getPage('privacy-policy').subscribe((post) => {
      this.post = post;
      this.seoService.setTitle('Politică de confidențialitate - Fun Bible');
      this.isLoading = false;
      this.seoService.setDescription(`${post.excerpt.rendered}`);
      this.meta.updateTag({ property: 'og:url', content: `https://funbible.net/privacy-policy/` });
      const initialKeywords = ['securitate', 'proiect', 'gdpr', 'confidentialitate', 'legislatie', 'informatii', 'legea', 'date', 'protectia datelor', 'cookie'].join();
      this.meta.updateTag({property: 'keywords', content: initialKeywords});

      this.angulartics2.eventTrack.next({
        action: post.title.rendered,
        properties: { category: 'pageView' },
      });
    }, () => {
      this.toastr.error('Acest conținut nu există!');
      this.isLoading = false;
    });
  }

  get postImage(): string {
    return `url(${this.post.featuredImage ? this.post.featuredImage : 'assets/logo.svg'})`;
  }
}
